/* Meer info op productkaarten: kort productoverzicht in een venster (op mobiel van onderen), zonder naar de productpagina te gaan */
(function () {
  'use strict';
  if (window.__cwQv) return; window.__cwQv = true;
  var dlg, body, last, bg = '';
  function cardBg(b){var m=b&&b.closest('.card--product, .cwh .card, li');var md=m&&(m.querySelector('.card__media')||m.querySelector('.st'));var c=md?getComputedStyle(md).backgroundColor:'';return c&&c!=='rgba(0, 0, 0, 0)'&&c!=='transparent'?c:'';}
  function make() {
    dlg = document.createElement('div');
    dlg.className = 'cwqv'; dlg.hidden = true;
    dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', 'cwqv-title');
    dlg.innerHTML = '<div class="cwqv-bg" data-cwqv-close></div><div class="cwqv-box"><button type="button" class="cwqv-x" data-cwqv-close aria-label="Sluiten"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="cwqv-body"></div></div>';
    document.body.appendChild(dlg);
    body = dlg.querySelector('.cwqv-body');
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-cwqv-close]')) close();
      if (e.target.closest('[data-cw-feat-add]')) setTimeout(close, 900);
    });
  }
  function open(url) {
    if (!dlg) make();
    body.innerHTML = '<div class="cwqv-load">Even laden...</div>';
    dlg.hidden = false; document.documentElement.classList.add('cwqv-open');
    requestAnimationFrame(function () { dlg.classList.add('is-on'); });
    var u = url.split('?')[0];
    fetch(u + '?section_id=cw-quick-view').then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var t = document.createElement('div'); t.innerHTML = html;
      var inner = t.querySelector('.cwqv-in');
      if (!inner) throw new Error('leeg');
      body.innerHTML = ''; body.appendChild(inner);
      var th = inner.querySelector('.cwqv-thumb, .cwqv-img'); if (th && bg && !th.classList.contains('is-photo')) th.style.background = bg;
      var x = dlg.querySelector('.cwqv-x'); if (x) x.focus();
    }).catch(function () { location.href = url; });
  }
  function close() {
    if (!dlg || dlg.hidden) return;
    dlg.classList.remove('is-on'); document.documentElement.classList.remove('cwqv-open');
    setTimeout(function () { dlg.hidden = true; body.innerHTML = ''; if (last) last.focus(); }, 200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cw-qv]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); last = b; bg = cardBg(b); open(b.getAttribute('data-cw-qv'));
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
